import ReactDOM from 'react-dom/client'
import { setFeatureFlagContextAccountId } from '../components/feature-flag/feature-flag.config'
import { ResearchClientOpenFeatureProvider } from '../components/feature-flag/research-provider/ResearchClientOpenFeatureProvider'
import { LauncherContainer } from '../components/LauncherContainer'
import { LauncherProvider } from '../components/LauncherProvider'
import { getResearchSettings } from './user-session-storage.util'

let launcherRoot: ReactDOM.Root | null = null

function getLauncherReactRoot() {
  const launcherRootEl = window.parent.document.querySelector<HTMLElement>('#cr-research-launcher')!
  if (!launcherRoot) {
    launcherRoot = ReactDOM.createRoot(launcherRootEl)
  }
  return launcherRoot
}

export async function renderResearchLauncher() {
  const reactRoot = getLauncherReactRoot()
  if (!reactRoot) {
    console.error('launcherRoot not found')
    return
  }

  const { accountId } = getResearchSettings()
  await setFeatureFlagContextAccountId(accountId)

  reactRoot.render(
    <ResearchClientOpenFeatureProvider>
      <LauncherProvider>
        <LauncherContainer key={new Date().getTime()} />
      </LauncherProvider>
    </ResearchClientOpenFeatureProvider>
  )
}
